import {
    SAVE_FEATURE_CONFIG_INFO,
    CLEAR_FEATURE_CONFIG_INFO
} from "../actions/ActionTypes"
import initialState from "./InitialState"
import { IFeatureConfig } from "../models/IFeatureConfig";

export const FeatureConfigInfoReducer = (state = initialState.featureConfigInfo, action: any): IFeatureConfig => {
    switch (action.type) {
        case SAVE_FEATURE_CONFIG_INFO:
            return { ...state, ...{[action.payload.configName]: action.payload.configValue} };
        case CLEAR_FEATURE_CONFIG_INFO:
            return {};
        default:
            return state;
    }
}